import type Phaser from 'phaser';

export function isPointerOverBlockingUI(pointer: { x: number; y: number }): boolean {
  const root = document.getElementById('hud');
  if (!root) return false;

  return document
    .elementsFromPoint(pointer.x, pointer.y)
    .some((el) => (
      root.contains(el)
      && el instanceof HTMLElement
      && !!el.closest('[data-block-game-input="true"]')
    ));
}

function viewportXY(pointer: Phaser.Input.Pointer | { x: number; y: number }): { x: number; y: number } {
  const ev = (pointer as Phaser.Input.Pointer).event as MouseEvent | undefined;
  if (ev && typeof ev.clientX === 'number' && typeof ev.clientY === 'number') {
    return { x: ev.clientX, y: ev.clientY };
  }
  return { x: pointer.x, y: pointer.y };
}

export function isPhaserPointerOverBlockingUI(pointer: Phaser.Input.Pointer | { x: number; y: number }): boolean {
  return isPointerOverBlockingUI(viewportXY(pointer));
}
